import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
/**
 * An info icon that'll show a tooltip on hover. The tooltip contains the passed {@link Props.serviceFeePercent|serviceFeePercent}.
 */ const InfoPostfix = ({ serviceFeePercent })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('estimatedEarnings.ready.tooltip', {
            serviceFeePercent
        })
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        "aria-label": t('estimatedEarnings.ready.tooltip', {
            serviceFeePercent
        }),
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }));
};
InfoPostfix.displayName = 'InfoPostfix';
export default InfoPostfix;
